<div ngClass="spacer" [ngStyle]="{ 'width': '100%', 'height': questionSpacer + 'px'}"></div>